import React from 'react';
import { ButtonBase } from '@mui/material';

interface ISkillButtons {
  label: string;
  id: string;
  onClick?: () => void;
  isActive?: boolean;
}

export const TechnicalSkillButton: React.FC<ISkillButtons> = ({ label, id, onClick, isActive }) => {
  return (
    <ButtonBase
      key={id}
      onClick={onClick}
      sx={{
        px: 1.5,
        py: 0.5,
        fontSize: '0.75rem',
        fontWeight: 500,
        borderRadius: '8px',
        transition: 'all 0.2s ease',
        bgcolor: isActive ? '#059669' : '#ecfdf5',
        color: isActive ? '#ffffff' : '#047857',
        border: '1px solid',
        borderColor: isActive ? '#059669' : '#a7f3d0',
        '&:hover': {
          bgcolor: isActive ? '#047857' : '#d1fae5',
        },
      }}
    >
      {label}
    </ButtonBase>
  );
};

export const BehavioralSkillButton: React.FC<ISkillButtons> = ({ label, id, onClick, isActive }) => {
  return (
    <ButtonBase
      key={id}
      onClick={onClick}
      sx={{
        px: 1.5,
        py: 0.5,
        fontSize: '0.75rem',
        fontWeight: 500,
        borderRadius: '8px',
        transition: 'all 0.2s ease',
        bgcolor: isActive ? '#2563eb' : '#eff6ff',
        color: isActive ? '#ffffff' : '#1d4ed8',
        border: '1px solid',
        borderColor: isActive ? '#2563eb' : '#bfdbfe',
        '&:hover': {
          bgcolor: isActive ? '#1d4ed8' : '#dbeafe',
        },
      }}
    >
      {label}
    </ButtonBase>
  );
};
